export const clearSearchInput =() => {
    const input = document.getElementById('search_input');
    if (input) {
      // Clear value
      const setter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        'value'
      )?.set;
      setter?.call(input, '');
  
      // Trigger input event
      const inputEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(inputEvent);
  
      // Focus the input to emulate user interaction
      input.focus();
  
      // Optionally trigger a 'focus' event manually (in case some systems use it)
      const focusEvent = new FocusEvent('focus', { bubbles: true });
      input.dispatchEvent(focusEvent);
    } else {
      console.warn('Search input with id "search_input" not found.');
    }
}